// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADING() {
      return {
        isLoading: true,
        mostCreativePeopleCommunitySectionPage:
          action.mostCreativePeopleCommunitySectionPage
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeopleCommunitySectionPage
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_PAGE_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleCommunitySectionPage.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
